import { CadastroVendedor } from './../interfaces/cadastro-vendedor';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CadastroAnaliseCredito } from '../interfaces/cadastro-analise-credito';
import { Cadastro } from '../interfaces/cadastro';

import { FatDoctoC } from '../interfaces/fat-docto-c';
import { MovtoDetails } from '../interfaces/movto-details';
import { Endereco } from '../interfaces/endereco';
import { CadCadastroContato } from '../interfaces/cad-cadastro-contato';
import { ConversaMensagem } from '../interfaces/conversa-mensagem';
import { CadastroOcorrencia } from '../interfaces/cadastro-ocorrencia';
import { Observable, of } from 'rxjs';
import { PageResult } from '../interfaces/page-result';

import { validaCnpj } from 'app/utils/documento';
import { JwtAuthService } from './auth/jwt-auth.service';
import { CadastroProjection } from '../interfaces/cadastro-projection copy';

/**
 * Created by Eldevan Nery Junior on 15/11/2020-15:40:10
 */
@Injectable({
  providedIn: 'root'
})
export class CadastroService {

  readonly path = '/cadastro';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) {}

  saveOrUpdateCliente(cadastro: Cadastro): Observable<Cadastro> {
    return this.http.put<Cadastro>(`${this.jwtAuthService.apiUrl + this.path}/cliente`, cadastro);
  }

  create(): Observable<Cadastro> {
    return this.http.post<Cadastro>(`${this.jwtAuthService.apiUrl + this.path}`, null);
  }

  saveOrUpdate(cadastro: Cadastro): Observable<Cadastro> {
    return this.http.put<Cadastro>(`${this.jwtAuthService.apiUrl + this.path}/v2`, cadastro);
  }

  getCadastroFisica(cpf: string, rg: string): Observable<Cadastro> {
    return this.http.get<Cadastro>(`${this.jwtAuthService.apiUrl + this.path}/fisica?cpf=${cpf}&rg=${rg}`);
  }

  getCadastroJuridica(cnpj: string, inscricao: string): Observable<Cadastro> {
    return this.http.get<Cadastro>(`${this.jwtAuthService.apiUrl + this.path}/juridica?cnpj=${cnpj}&inscricao=${inscricao}`);
  }

  getCadastroJuridicaCert(cnpj: string, uf: string): Observable<any> {
    if (cnpj != null && cnpj !== '') {
      cnpj = cnpj.replace(/\D/g, '');
    }
    if (cnpj !== '') {
      if (validaCnpj(cnpj)) {
        return this.http.get(`${this.jwtAuthService.apiUrl + this.path}/juridica/cert?cnpj=${cnpj}&uf=${uf}`);
      }
    }
    return of({});
  }

  getCadastroJuridicaProxy(cnpj: string): Observable<any> {
    if (cnpj != null && cnpj !== '') {
      cnpj = cnpj.replace(/\D/g, '');
    }
    if (cnpj !== '') {
      if (validaCnpj(cnpj)) {
        
        return this.http.get(`${this.jwtAuthService.apiUrl + this.path}/juridica/proxy?cnpj=${cnpj}`);
      }
    }
    return of({});
  }


  getCadastro(id: number): Observable<Cadastro> {
    return this.http.get<Cadastro>(`${this.jwtAuthService.apiUrl + this.path}/?cadastroId=${id}`);
  }

  deleteCadastro(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }


  getCadastroPage(page?: number, size?: number, order?: string,
    direction?: string, desativado?: boolean, tipoCadastro?: string, aniversariantes?: boolean,
    aniversariantesData?: string): Observable<PageResult<Cadastro>> {
    let params = new HttpParams()
      .set('page', String(page ?? 1))
      .set('size', String(size ?? 20))
      .set('order', order ?? 'NENHUM')
      .set('direction', direction ?? 'ASC')
      .set('desativado', String(desativado ?? false))
      .set('tipoCadastro', tipoCadastro ?? 'TODOS');
    if (aniversariantes) {
      params = params.set('aniversariantes', 'true');
      if (aniversariantesData) {
        params = params.set('aniversariantesData', aniversariantesData);
      }
    }
    return this.http.get<PageResult<Cadastro>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/v2`, { params });
  }

  getCadastroProjectionPage(page?: number, size?: number, order?: string, direction?: string, desativado?: boolean, tipoCadastro?: string): Observable<PageResult<CadastroProjection>> {
    return this.http.get<PageResult<CadastroProjection>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/projection?page=${page}&size=${size}`
      + `&order=${order}&direction=${direction ?? 'ASC'}&desativado=${desativado ?? false}&tipoCadastro=${tipoCadastro ?? 'TODOS'}`);
  }

  getCadastroPageSearch(page?: number, size?: number,
    search?: string, order?: string, direction?: string, desativado?: boolean, tipoCadastro?: string): Observable<PageResult<Cadastro>> {
    let params = new HttpParams()
      .set('page', String(page ?? 1))
      .set('size', String(size ?? 20))
      .set('order', order ?? 'NENHUM')
      .set('direction', direction ?? 'ASC')
      .set('desativado', String(desativado ?? false))
      .set('tipoCadastro', tipoCadastro ?? 'TODOS');
    if (search != null && String(search).trim() !== '') {
      params = params.set('search', String(search).trim());
    }
    return this.http.get<PageResult<Cadastro>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/v2`, { params });
  }

  getCadastroProjectionPageSearch(page?: number, size?: number, search?: string, order?: string, direction?: string, desativado?: boolean, tipoCadastro?: string): Observable<PageResult<CadastroProjection>> {
    return this.http.get<PageResult<CadastroProjection>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/projection?page=${page}&size=${size}&search=${search}`
      + `&order=${order}&direction=${direction ?? 'ASC'}&desativado=${desativado ?? false}&tipoCadastro=${tipoCadastro ?? 'TODOS'}`);
  }

  getMovto(page?: number, size?: number, order?: string, direction?: string, cadastroId?: string,
    dataInicial?: string, dataFinal?: string): Observable<PageResult<FatDoctoC>> {
    return this.http.get<PageResult<FatDoctoC>>(`${this.jwtAuthService.apiUrl + this.path}/movto/page/get/v2?page=${page}&size=${size}`
      + `&cadastroId=${cadastroId}&dataInicial=${dataInicial}&dataFinal=${dataFinal}&order=${order}&direction=${direction}`);
  }

  getMovtoDetails(cadastroId: string): Observable<MovtoDetails> {
    return this.http.get<MovtoDetails>(`${this.jwtAuthService.apiUrl + this.path}/movto/details?cadastroId=${cadastroId}`);
  }

  getAnaliseCreditoDetails(cadastroId: string): Observable<CadastroAnaliseCredito> {
    return this.http.get<CadastroAnaliseCredito>(`${this.jwtAuthService.apiUrl + this.path}/analise-credito/details?cadastroId=${cadastroId}`);
  }

  getPageEndereco(page?: number, size?: number, order?: string,
    direction?: string, cadastroId?: string): Observable<PageResult<Endereco>> {
    return this.http.get<PageResult<Endereco>>(`${this.jwtAuthService.apiUrl + this.path}/endereco/page/get/?page=${page}&size=${size}`
      + `&cadastroId=${cadastroId}&order=${order}&direction=${direction ?? 'ASC'}`);
  }

  getPageVendedor(page?: number, size?: number, order?: string,
    direction?: string, cadastroId?: string): Observable<PageResult<CadastroVendedor>> {
    return this.http.get<PageResult<CadastroVendedor>>(`${this.jwtAuthService.apiUrl + this.path}/vendedor/page/get/?page=${page}&size=${size}`
      + `&cadastroId=${cadastroId}&order=${order}&direction=${direction ?? 'ASC'}`);
  }

  /**
   * Contatos do cadastro — mesmo contrato dos endereços, para as duas abas se comportarem igual.
   */
  /**
   * Conversa de WhatsApp do cliente — somente leitura.
   *
   * Vem por cadastro e não por telefone: o mesmo cliente pode falar de mais de um número, e para
   * quem atende a conversa é uma só.
   */
  getPageConversa(page?: number, size?: number, cadastroId?: string): Observable<PageResult<ConversaMensagem>> {
    return this.http.get<PageResult<ConversaMensagem>>(
      `${this.jwtAuthService.apiUrl + this.path}/conversa/page/get/?page=${page}&size=${size}&cadastroId=${cadastroId}`);
  }

  // /cadastro-contato e nao /contato: este ultimo e do CadContatoController, que publica outra
  // entidade (CadContato, do schema padrao). Nomes parecidos, coisas diferentes.
  getPageContato(page?: number, size?: number, cadastroId?: string): Observable<PageResult<CadCadastroContato>> {
    return this.http.get<PageResult<CadCadastroContato>>(
      `${this.jwtAuthService.apiUrl + this.path}/cadastro-contato/page/get/?page=${page}&size=${size}&cadastroId=${cadastroId}`);
  }

  saveOrUpdateContato(contato: CadCadastroContato): Observable<CadCadastroContato> {
    return this.http.put<CadCadastroContato>(`${this.jwtAuthService.apiUrl + this.path}/cadastro-contato`, contato);
  }

  deleteCadastroContato(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/cadastro-contato/${id}`);
  }

  saveOrUpdateEndereco(endereco: Endereco): Observable<Endereco> {
    return this.http.put<Endereco>(`${this.jwtAuthService.apiUrl + this.path}/endereco`, endereco);
  }

  deleteCadastroEndereco(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/endereco/${id}`);
  }
  saveOrUpdateVendedor(cadastroVendedor: CadastroVendedor): Observable<CadastroVendedor> {
    return this.http.put<CadastroVendedor>(`${this.jwtAuthService.apiUrl + this.path}/vendedor`, cadastroVendedor);
  }

  deleteCadastroVendedor(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/vendedor/${id}`);
  }

  getPageOcorrencia(page?: number, size?: number, order?: string,
    direction?: string, cadastroId?: string): Observable<PageResult<CadastroOcorrencia>> {
    return this.http.get<PageResult<CadastroOcorrencia>>(`${this.jwtAuthService.apiUrl + this.path}/ocorrencia/page/get/?page=${page}&size=${size}`
      + `&cadastroId=${cadastroId}&order=${order}&direction=${direction ?? 'DESC'}`);
  }

  getOcorrenciasList(cadastroId: number): Observable<CadastroOcorrencia[]> {
    return this.http.get<CadastroOcorrencia[]>(`${this.jwtAuthService.apiUrl + this.path}/ocorrencia/list/get?cadastroId=${cadastroId}`);
  }

  saveOrUpdateOcorrencia(cadastroId: number, ocorrencia: CadastroOcorrencia): Observable<CadastroOcorrencia> {
    return this.http.put<CadastroOcorrencia>(`${this.jwtAuthService.apiUrl + this.path}/ocorrencia?cadastroId=${cadastroId}`, ocorrencia);
  }

  deleteCadastroOcorrencia(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/ocorrencia/${id}`);
  }




}
